import Immutable from 'immutable';

import {THEMES} from '@services/utilities';

import {OPEN_ACCOUNT_WIDGET, CLOSE_ACCOUNT_WIDGET, SET_IS_MOBILE, SET_THEME} from '../actions/ui';
import {
  START_PASSWORD_RESET,
  PASSWORD_RESET_SUCCESS,
  PASSWORD_RESET_ERROR,
  START_SETTING_NEW_PASSWORD,
  NEW_PASSWORD_SETTING_SUCCESS,
  PASSWORD_MISSING_SYMBOLS,
  PASSWORD_MISSING_LETTERS,
  PASSWORD_MISSING_NUMBERS,
  PASSWORD_MISSING_MIXEDCASE,
  PASSWORD_COMPROMISED,
  NEW_PASSWORD_SETTING_ERROR,
  START_GIVING_PRIVACY_CONSENT,
  GIVING_PRIVACY_CONSENT_SUCCESS,
  GIVING_PRIVACY_CONSENT_ERROR,
} from '../actions/login';

const initialState = Immutable.fromJS({
  accountWidgetOpen: false,
  isResettingPassword: false,
  isSettingNewPassword: false,
  isGivingPrivacyConsent: false,
  isMobile: window.matchMedia('(min-width: 320px) and (max-width: 480px)').matches || false,
  isLegacyBrowser: Boolean(!('getUserMedia' in navigator || 'MediaDevices' in window)),
  theme: null,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case OPEN_ACCOUNT_WIDGET:
      return state.set('accountWidgetOpen', true);

    case CLOSE_ACCOUNT_WIDGET:
      return state.set('accountWidgetOpen', false);

    case START_PASSWORD_RESET:
      return state.set('isResettingPassword', true);

    case PASSWORD_RESET_SUCCESS:
    case PASSWORD_RESET_ERROR:
      return state.set('isResettingPassword', false);

    case START_SETTING_NEW_PASSWORD:
      return state.set('isSettingNewPassword', true);

    case NEW_PASSWORD_SETTING_SUCCESS:
    case PASSWORD_MISSING_SYMBOLS:
    case PASSWORD_MISSING_LETTERS:
    case PASSWORD_MISSING_NUMBERS:
    case PASSWORD_MISSING_MIXEDCASE:
    case PASSWORD_COMPROMISED:
    case NEW_PASSWORD_SETTING_ERROR:
    case NEW_PASSWORD_SETTING_ERROR:
      return state.set('isSettingNewPassword', false);

    case START_GIVING_PRIVACY_CONSENT:
      return state.set('isGivingPrivacyConsent', true);

    case GIVING_PRIVACY_CONSENT_SUCCESS:
    case GIVING_PRIVACY_CONSENT_ERROR:
      return state.set('isGivingPrivacyConsent', false);

    case SET_IS_MOBILE:
      return state.set('isMobile', action.isMobile || false);

    case SET_THEME:
      return state.set('theme', action.themeId || THEMES.BASIC);

    default:
      return state;
  }
}

/* Selectors */

export function getIsLegacyBrowser(state) {
  return state.getIn(['ui', 'isLegacyBrowser']);
}

export function getIsMobile(state) {
  return state.getIn(['ui', 'isMobile']);
}

export function isAccountWidgetOpen(state) {
  return Boolean(state && state.getIn(['ui', 'accountWidgetOpen']));
}

export function isResettingPassword(state) {
  return Boolean(state && state.getIn(['ui', 'isResettingPassword']));
}

export function isSettingNewPassword(state) {
  return Boolean(state && state.getIn(['ui', 'isSettingNewPassword']));
}

export function isGivingPrivacyConsent(state) {
  return Boolean(state && state.getIn(['ui', 'isGivingPrivacyConsent']));
}

export function getThemeId(state) {
  return state?.getIn(['ui', 'theme']) || 1;
}

export function isCalendarTheme(state) {
  if (!state?.getIn(['ui', 'theme'])) {
    return null;
  }

  return state?.getIn(['ui', 'theme']) === THEMES.CALENDAR;
}

export function isFerrariTheme(state) {
  if (!state?.getIn(['ui', 'theme'])) {
    return null;
  }

  return state?.getIn(['ui', 'theme']) === THEMES.FERRARI;
}
